<template>
<v-dialog v-model="dialog" :max-width="options.width" :persistent="options.persistent" @keydown.esc="cancel()">
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-toolbar dense dark class="primary elevation-1">
          <v-toolbar-title>Notify</v-toolbar-title>

          <v-spacer></v-spacer>
          <v-btn icon @click.native="cancel" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
      <v-card>
         <v-card-text>
           <v-datetime-picker
           label="Select end time"
           v-model="form.datetime"
           time-format="HH:mm"
           date-format="dd/MM/yyyy"
           :text-field-props="{ 'prepend-icon': 'timer'}"
           > </v-datetime-picker>
         </v-card-text>

        <v-card-text class="text-center text-h6 py-0"><v-icon>drive_eta</v-icon> {{ data.driver }}</v-card-text>

        <v-card-text v-if="data">
          <div class="notify-info">
            <div class="price">{{ data.price | currency }}</div>
            <div>Date: {{ booking.date }} </div>
            <div> {{ types[booking.type || 'to'].label}} : {{ booking.picktime | formatTime }}</div>

            <div v-if="other && other.type" class="notify-other" :class="{ 'added-other': otherAdded}">

              <span v-show="!otherAdded">+</span><span> {{ types[other.type || 'back'].label}} : {{ other.picktime | formatTime }}</span>
              <v-btn icon @click="updateOther(other)" >
                <v-icon v-if="otherAdded" small color="primary">remove_circle</v-icon>
                <v-icon v-else small color="primary">add_circle</v-icon>
              </v-btn>
            </div>
          </div>
          </v-card-text>

        <v-card-actions>
          <v-btn block
          dark
          color="primary" @click.native="save">Send</v-btn>
        </v-card-actions>
      </v-card>
      </v-form>
    </v-dialog>
</template>

<script>
import FormMixin from '@/mixins/formvalid';
import moment from 'moment';
import notify from './notify';
export default {
  mixins: [FormMixin],
  props: {
    selectedCallback: Function
  },
  data () {
    return {
      id: null,
      dialog: false,
      resolve: null,
      reject: null,
      timer : null,
      menu_time : false,
      addedOther: false,
      options: {
        persistent: false,
        color: 'primary',
        width: 600
      },
      other: {},
      valid: false,
      form: {
        msg: 'newbooking'
      },
      types: {
        back: {label: 'Retour', color: 'black', icon: 'keyboard_return'},
        to: {label: 'Aller', color: 'primary', icon: 'arrow_forward'},
        simple: {label: 'Simple', color: 'grey', icon: 'unfold_more'}
      },
      data: {},
      booking: [],
      bookings: []
    };
  },
  methods: {
    cancel () {
      this.resolve(false);
      this.dialog = false;
    },
    save () {
      if (this.$refs.form.validate()) {

        this.form = this.prepareBooking();
        console.log('booking:', this.form);
        this.resolve(this.form);
        this.dialog = false;
      }
    },
    open (item, options) {
      if (!item || !item.json) return;
      this.options = Object.assign(this.options, options);

      this.getReverseType(item).then((result) => {
        console.log('getReverseType : ', result);
        this.dialog = true;
        this.bookings = [];
        this.data = {
          driver: (item.driver_lastname + ' ' +  item.driver_firstname),
          price: item.price_driver
        };

        this.form.id = item.id;
        this.form.driverId = item.driverId;
        this.form.timer = moment('00:15').format('HH:mm');
        this.form.datetime = moment().add(15, 'm').format('DD/MM/YYYY HH:mm');

        this.booking = notify.booking(item);
        this.other = notify.booking(result[0]);

        this.bookings.push(this.booking);

        this.updateTime();
      });

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    updateTime () {
      var diff = moment(this.form.datetime).diff(moment() ,'s');
      this.form.endtime = moment(this.form.datetime).format('DD/MM/YYYY HH:mm');
      this.form.timer = diff > 0 ? diff : 0;
      this.form.timestamp = moment().format('DD/MM/YY HH:mm');
    },
    updateOther (b) {
      if (!this.otherAdded ) {
        console.log('add updateOther');
        if(b) {
          this.bookings.push(b);
          this.data.price = (this.booking.price + b.price);
        }
      } else {
        console.log('remove updateOther');
        this.data.price = this.booking.price;
        this.bookings.pop();
      }
      this.$forceUpdate();
    },
    prepareBooking () {
      var form = this.form;
      form.bookings = this.bookings;
      form.price = this.data.price;
      form.other = this.bookings[1] || null;

      if (this.other) {
        form.bookings.sort((a, b) => moment(a.pickTime, 'HH:mm').diff(moment(b.pickTime, 'HH:mm')));
      }

      this.updateTime();
      return form
    },
    getReverseType (b) {
      // var app = this;
      console.log('getReverseType 2: ', b);
      return new Promise((resolve, reject) => {
        this.$http
        .post('service/booking/byReverseType', {
          ap_date : moment(b.ap_date, 'DD/MM/YYYY').format('YY-MM-DD'),
          clientId : b.clientId,
          destinationId : b.destinationId,
          driverId : b.driverId,
          type : b.type
        }).then(response => {
          resolve(response.data);
        })
        .catch(function (error) {
          reject(error);
        });
      });
    },
  },
  computed: {
    otherAdded: {
      cache: false,
      get () {
        return (this.bookings && this.bookings.length > 1 && true) || false;
      }
    }
  },
  filters: {
    removeSeconds(v) {
      var arr = v.split(':');
      return arr[0] + ':' + arr[0];
    }
  },
  created () {
    // this.getDrivers();
  }
};
</script>

<style lang="scss">
  .notify-info {
    border: solid 1px rgb(223, 221, 221);
    border-radius: 4px;
    padding: 8px;
    position: relative;
    .price {
      color: #333;
      font-size: 20px;
      position: absolute;
      top: 10px;
      right: 10px;
    }
    .notify-other {
      border-top: solid 1px #ccc;
      margin-top: 4px;
      padding: 4px;
      position: relative;
      color: $primary;

      &.added-other {
        border-top: none;
        color: #888;
        padding: 0;
      }

      .v-btn {
        position: absolute;
        top:0;
        right:0;
      }
    }
  }
</style>
